// Revisado: 2026-02-13 [I18n Scan]
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * RoomCard - Componente de UI para visualizar una sala disponible
 * 
 * @param {object} room - Datos de la sala {room_id, players, created_at}
 * @param {function} onJoin - Función a ejecutar al clickear "Join"
 */
const RoomCard = ({ room, onJoin }) => {
    const { t } = useTranslation();

    return (
        <div className="bg-gray-800 border border-gray-700 rounded-lg p-4 hover:border-teal-500 transition-colors shadow-lg">
            <h3 className="text-xl font-bold text-white mb-2 truncate" title={room.room_id}>
                {t('RoomCard.title', { room_id: room.room_id, defaultValue: `Room: ${room.room_id}` })}
            </h3>

            <div className="flex justify-between items-center mb-4">
                <span className="text-gray-400 text-sm">
                    {t('RoomCard.players', 'Players:')} <span className="text-white font-bold">{room.players || 0}/2</span>
                </span>

                {room.status === 'IN_PROGRESS' && (
                    <span className="bg-yellow-600/50 text-yellow-200 text-xs px-2 py-1 rounded">
                        {t('RoomCard.status_progress', 'In Progress')}
                    </span>
                )}
            </div>

            <button
                onClick={onJoin}
                disabled={room.players >= 2 || room.status === 'IN_PROGRESS'}
                className="w-full bg-gray-700 hover:bg-gray-600 text-white py-2 rounded-lg transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
            >
                {room.players >= 2 ? t('RoomCard.btn_full', 'Full') : t('RoomCard.btn_join', 'Join Room')}
            </button>
        </div>
    );
};

export default RoomCard;
